import {css} from 'lit';

export const checkboxStyles = css`

  :host {
    --checkbox__color: var(--_checkbox__color, var(--sbkCheckboxFgColorOnLightDefault));
    --checkbox__color--active: var(--_checkbox__color--active, var(--sbkCheckboxFgColorOnLightActive));
    --checkbox__color--hover: var(--_checkbox__color--hover, var(--sbkCheckboxFgColorOnLightHover));
    --checkbox__color--focus: var(--_checkbox__color--focus, var(--sbkCheckboxFgColorOnLightDefault));
    --checkbox__color--disabled: var(--_checkbox__color--disabled, var(--sbkCheckboxFgColorOnLightDisabled));
    --checkbox__color--error: var(--_checkbox__color--error, var(--sbkCheckboxFgColorOnLightError));

    --checkbox-icon__color: var(--_checkbox-icon__color, var(--sbkCheckboxFgColorOnLightDefault));
    --checkbox-icon__color--active: var(--_checkbox-icon__color--active, var(--sbkCheckboxFgColorOnLightDefault));
    --checkbox-icon__color--hover: var(--_checkbox-icon__color--hover, var(--sbkCheckboxFgColorOnLightDefault));
    --checkbox-icon__color--focus: var(--_checkbox-icon__color--focus, var(--sbkCheckboxFgColorOnLightDefault));
    --checkbox-icon__color--disabled: var(--_checkbox-icon__color--disabled, var(--sbkCheckboxFgColorOnLightDisabled));
    --checkbox-icon__color--error: var(--_checkbox-icon__color--error, var(--sbkCheckboxFgColorOnLightError));

    --checkbox__bg: var(--_checkbox__bg, var(--sbkCheckboxBgColorOnLightEnabled));
    --checkbox__bg--active: var(--_checkbox__bg--active, var(--sbkCheckboxBgColorOnLightActive));
    --checkbox__bg--hover: var(--_checkbox__bg--hover, var(--sbkCheckboxBgColorOnLightHover));
    --checkbox__bg--focus: var(--_checkbox__bg--focus, var(--sbkCheckboxBgColorOnLightFocus));
    --checkbox__bg--disabled: var(--_checkbox__bg--disabled, var(--sbkCheckboxBgColorOnLightDisabled));
    --checkbox__bg--error: var(--_checkbox__bg--error, var(--sbkCheckboxBgColorOnLightError));

    --checkbox__border: var(--_checkbox__border, var(--sbkCheckboxBorderOnLightEnabled));
    --checkbox__border--active: var(--_checkbox__border--active, var(--sbkCheckboxBorderOnLightActive));
    --checkbox__border--disabled: var(--_checkbox__border--disabled, var(--sbkCheckboxBorderOnLightDisabled));
    --checkbox__border--focus: var(--_checkbox__border--focus, var(--sbkCheckboxBorderOnLightFocus));
    --checkbox__border--hover: var(--_checkbox__border--hover, var(--sbkCheckboxBorderOnLightHover));
    --checkbox__border--readonly: var(--_checkbox__border--readonly, var(--sbkCheckboxBorderOnLightDisabled));
    --checkbox__border--error: var(--_checkbox__border--error, var(--sbkCheckboxBorderOnLightError));

    --checkbox__margin-bottom: var(--_checkbox__margin-bottom, var(--sbkCoreSpacingMd));
    width: fit-content;
  }

  * {
    margin: 0;
    padding: 0;
  }

  .sr-only {
    position: absolute;
    clip: rect(1px, 1px, 1px, 1px);
    padding: 0;
    border: 0;
    height: 1px;
    width: 1px;
    overflow: hidden;
  }

  .checkbox__wrapper {
    position: relative;
    margin-bottom: var(--checkbox__margin-bottom);
      font: var(--sbkCheckboxLabelSm);
  }

  .checkbox__wrapper .checkbox__checked + .checkbox__label .icon {
    display: flex;
  }

  .checkbox__wrapper input:focus:not(:focus-visible) {
    outline: none;
  }

  .checkbox__wrapper input[disabled] + .checkbox__label {
    color: var(--checkbox__color--disabled);

    .icon {
      color: var(--checkbox-icon__color--disabled);
    }

    .checkbox__icon:before {
      border: var(--checkbox__border--disabled);
      background: var(--checkbox__bg--disabled);
    }
  }

  .checkbox__wrapper input[readonly] + .checkbox__label {
    color: var(--checkbox__color--disabled);
    cursor: default;

    .icon {
      color: var(--checkbox-icon__color--disabled);
    }

    .checkbox__icon:before {
      border: var(--checkbox__border--disabled);
      background: var(--checkbox__bg--disabled);
    }
  }

  .checkbox__wrapper input:focus-visible + .checkbox__label {
    color: var(--checkbox__color--focus);

    .icon {
      color: var(--checkbox-icon__color--focus);
    }

    .checkbox__icon:before {
      outline: var(--checkbox__border--focus);
      outline-offset: 2px;
    }
  }

  .checkbox__wrapper--error {
    .checkbox__label {
      color: var(--checkbox__color--error);

      sbk-icon {
        color: var(--checkbox-icon__color--error);
      }

      .checkbox__icon:before {
        background-color: var(--checkbox__bg);
        border: var(--checkbox__border--error);
      }
    }
  }

    .checkbox__icon {
        display: flex;
        align-self: baseline;
    }

    .checkbox__icon:before {
        content: " ";
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        width: var(--sbkCheckboxMd);
        height: var(--sbkCheckboxMd);
        border: var(--checkbox__border);
        border-radius: var(--sbkCheckboxBorderRadiusDefault);
        background-color: var(--checkbox__bg);

        margin-right: var(--sbkCheckbox2xs);
        position: relative;
    }

    .icon {
        color: var(--checkbox-icon__color);
        position: absolute;
        display: none;
    }

  .checkbox__label {
    cursor: pointer;
    position: relative;
    display: flex;
    align-items: center;
    

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        color: var(--checkbox__color--hover);
          
          .icon {
          color: var(--checkbox-icon__color--hover);
        }

        .checkbox__icon:before {
          background: var(--checkbox__bg--hover);
          border: var(--checkbox__border--hover);
        }
      }
    }

    &:active {
      color: var(--checkbox__color--active);

        .icon {
        color: var(--checkbox-icon__color--active);
      }

      .checkbox__icon:before {
        background: var(--checkbox__bg--active);
        border: var(--checkbox__border--active);
      }
    }
  }

  .checkbox__label--missing {
    height: var(--sbkCheckboxMd);
  }
`;
